import { PRIZES_SERVICE } from "@/services/prizes.service.js";

const state = {postPrizeOutput: false, putPrizeOutput: false, getPrizesOutput: {}, getPrizeDetailsOutput: {}, deletePrizeByIdOutput: false};

const actions = {
    //Service to create prizes
    postPrize({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postPrizeRequest');

        PRIZES_SERVICE.postPrize(input)
            .then(
                output => {
                    commit('postPrizeSuccess', output);
                },
                error => {
                    commit('postPrizeFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update prizes
    putPrize({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putPrizeRequest');

        PRIZES_SERVICE.putPrize(input)
            .then(
                output => {
                    commit('putPrizeSuccess', output);
                },
                error => {
                    commit('putPrizeFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get paginated prizes
    getPrizes({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getPrizesRequest');

        PRIZES_SERVICE.getPrizes(queryParams)
            .then(
                output => {
                    commit('getPrizesSuccess', output);
                },
                error => {
                    commit('getPrizesFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get prize. NOT IMPLEMENTED
    getPrizeDetails({ dispatch, commit }, uniqueIdentifier) {
        dispatch('alert/clear', null, { root: true });
        commit('getPrizeDetailsRequest');

        PRIZES_SERVICE.getPrizeDetails(uniqueIdentifier)
            .then(
                output => {
                    commit('getPrizeDetailsSuccess', output);
                },
                error => {
                    commit('getPrizeDetailsFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to delete prizes
    deletePrizeById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('deletePrizeByIdRequest');

        PRIZES_SERVICE.deletePrizeById(id)
            .then(
                output => {
                    commit('deletePrizeByIdSuccess', output);
                },
                error => {
                    commit('deletePrizeByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //postPrize
    postPrizeRequest(state) {
        state.postPrizeOutput = null;
    },
    postPrizeSuccess(state, output) {
        state.postPrizeOutput = true;
    },
    postPrizeFailure(state) {
        state.postPrizeOutput = false;
    },

    //putPrize
    putPrizeRequest(state) {
        state.putPrizeOutput = null;
    },
    putPrizeSuccess(state, output) {
        state.putPrizeOutput = true;
    },
    putPrizeFailure(state) {
        state.putPrizeOutput = false;
    },

    //getPrizes
    getPrizesRequest(state) {
    },
    getPrizesSuccess(state, output) {
        state.getPrizesOutput = output;
    },
    getPrizesFailure(state) {
        state.getPrizesOutput = false;
    },

    //getPrizeDetails
    getPrizeDetailsRequest(state) {
    },
    getPrizeDetailsSuccess(state, output) {
        state.getPrizeDetailsOutput = output;
    },
    getPrizeDetailsFailure(state) {
        state.getPrizeDetailsOutput = false;
    },

    //deletePrizeById
    deletePrizeByIdRequest(state) {
        state.deletePrizeByIdOutput = null;
    },
    deletePrizeByIdSuccess(state, output) {
        state.deletePrizeByIdOutput = true;
    },
    deletePrizeByIdFailure(state) {
        state.deletePrizeByIdOutput = false;
    },
};

export const prizes = {
    namespaced: true,
    state,
    actions,
    mutations
};